(() => {
    const searchForm = document.querySelector("form.search-catalogue-form") 
    if (searchForm) {
        searchForm.addEventListener("submit", (e) => {
            e.preventDefault();
            const query = encodeURI(searchForm.querySelector("input[name='q']").value)

            var url = "https://kapiti.spydus.co.nz/cgi-bin/spydus.exe/ENQ/OPAC/BIBENQ?ENTRY=" + query + "&ENTRY_NAME=BS&ENTRY_TYPE=K&SORTS=SQL_REL_BIB&GQ=" + query + "&ISGLB=1&NRECS=20&QRY=&QRYTEXT=Full+catalogue&_SPQ=2";
            window.open(url);

        })
    }
})();